export default __webpack_public_path__ + "static/media/18.677e92df.png";